import React from 'react';
import { WithSmokers } from './WithSmokers';
import { SimpleCleanSatisfyingScenes } from './SimpleCleanSatisfyingScenes';
import { ScrollingAnimationsProvider } from './ScrollAnimationsProvider';

export const ScrollingAnimationsContainer = ({ starterKitData }) => {
  return (
    <ScrollingAnimationsProvider>
      <div className="Animation__starter-kit content-wrapper">
        <WithSmokers {...starterKitData} />
        <SimpleCleanSatisfyingScenes />
      </div>
    </ScrollingAnimationsProvider>
  );
};
